import type {
  LearnerNoticeMaterialType,
  OfflineMaterials,
} from '@/types/configurationV2'

type MaterialAvailabilityKey = 'checkupBook' | 'workbook'

export function createDefaultOfflineMaterials(): OfflineMaterials {
  return {
    checkupBook: true,
    workbook: true,
  }
}

export function setMaterialAvailability(
  materials: OfflineMaterials,
  key: MaterialAvailabilityKey,
  value: boolean,
): OfflineMaterials {
  return {
    ...materials,
    [key]: value,
  }
}

export function setLearnerNoticeMaterialType(
  materials: OfflineMaterials,
  value: LearnerNoticeMaterialType | undefined,
): OfflineMaterials {
  const next = { ...materials }

  if (value === undefined) {
    delete next.learnerNoticeMaterialType
  } else {
    next.learnerNoticeMaterialType = value
  }

  return next
}
